"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

var _Icon = _interopRequireDefault(require("../ImagesAndIcons/Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const Button = _styledComponents.default.button.withConfig({
  displayName: "DropdownButton__Button",
  componentId: "design-system__sc-1m0i3bw-0"
})(["color:", ";background:none;border:none;font-family:Roboto;font-size:1rem;line-height:15px;display:flex;align-items:center;cursor:pointer;height:32px;> div{margin-right:14px;}&:hover:enabled{background:", ";}&:disabled{color:", ";cursor:default;}"], _BaseTheme.default.colors.blue, _BaseTheme.default.colors.bluegray, _BaseTheme.default.colors.lightgray);

const DropdownButton = _ref => {
  let {
    children,
    icon
  } = _ref,
      props = _objectWithoutProperties(_ref, ["children", "icon"]);

  return /*#__PURE__*/_react.default.createElement(Button, props, icon && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: icon,
    size: "16"
  }), ' ', children);
};

DropdownButton.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,
  icon: _propTypes.default.string
};
DropdownButton.defaultProps = {
  icon: undefined
};
var _default = DropdownButton;
exports.default = _default;